import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

import { getInitialSelectedOptions, getInitialSelectedVariant, getNewSelectedOptions, getSelectedVariant, doesSelectedVariantExist } from '../Utils/VariantUtils';

var useSelectedVariant = function useSelectedVariant(product) {
  var initialSelectedVariant = null;
  var initialSelectedOptions = null;

  if (product) {
    // if product on load (PDP)
    initialSelectedVariant = getInitialSelectedVariant(product.variants.edges);
    initialSelectedOptions = getInitialSelectedOptions(initialSelectedVariant);
  }

  var _useState = useState({
    variant: initialSelectedVariant,
    options: initialSelectedOptions
  }),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      productModalDataActive = _useState4[0],
      setProductModalDataActive = _useState4[1];

  // if product prop changes (collection page modal)


  useEffect(function () {
    if (product) {
      var newSelectedVariant = getInitialSelectedVariant(product.variants.edges);
      var newSelectedOptions = getInitialSelectedOptions(newSelectedVariant);
      setSelected({
        variant: newSelectedVariant,
        options: newSelectedOptions
      });
      setProductModalDataActive(true);
    }
  }, [product]);

  var handleOptionChange = function handleOptionChange(event) {
    var newSelectedOptions = getNewSelectedOptions(selected.options, event.target);

    var newSelectedVariant = getSelectedVariant(product.variants.edges, newSelectedOptions);
    if (newSelectedVariant != undefined) {
      setSelected({ variant: newSelectedVariant, options: newSelectedOptions });
    } else {
      // only update options
      setSelected(Object.assign({}, selected, { options: newSelectedOptions }));
    }
  };

  var variantExists = doesSelectedVariantExist(selected.options, selected.variant);

  return [selected, handleOptionChange, variantExists, productModalDataActive];
};

export default useSelectedVariant;